/** What an event is used for. Matches the EventType enum in the API. */
export enum EventType {
    /** Guests sign up for one or more times. Places can be limited and there can be a waitlist. */
    SignUp = 0,
    /** Guests vote for the times that suit them. A poll can't be fully booked. */
    Poll = 1
}
